import React from 'react';
import TreeView from '../../application-controls/tree-view';
import TreeLeaf from './tree-list-item-dataset';
import { connect } from 'redux-bundler-react';

class TreeListContainer extends React.Component {
  render() {
    const { treeRootNode } = this.props;
    const items = treeRootNode.children || [];
    
      return(<TreeView
        data={items}
        components={[TreeLeaf]}
        componentMatches={[]}
      />)
    
  }
}

export default connect(
  'selectTreeRootNode',
  TreeListContainer
)